export enum PropertyHouseStoreys {
    SINGLE_STOREY = 1,
    MULTI_STOREY = 2
}
export enum PropertyHouseStoreys {
    SINGLE_STOREY = 1,
    MULTI_STOREY = 2
}
